// extracted by mini-css-extract-plugin
export var activityContainer = "_nw-0";
export var typingIndicatorContainer = "_nw-1";
export var typingIndicatorDot = "_nw-2";
export var wave = "_nw-3";